import { render } from "./Browser.vue?vue&type=template&id=2cfe267e&scoped=true"
import script from "./Browser.vue?vue&type=script&lang=js"
export * from "./Browser.vue?vue&type=script&lang=js"

import "./Browser.vue?vue&type=style&index=0&id=2cfe267e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfe267e"]])

export default __exports__